import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import { INTER, SLATE } from '../../studentStyles';

// The small all-caps eyebrow that names the exercise type at the top of a card.
export default function ExerciseLabel({ children }: { children: ReactNode }) {
    return (
        <Typography sx={{ fontFamily: INTER, fontWeight: 600, fontSize: 11, letterSpacing: '0.08em', color: SLATE, mb: 1.5 }}>
            {children}
        </Typography>
    );
}
